import { createSelector } from '@ngrx/store'
import { AppState } from '../../../../store'

import * as fromUser from '../reducers/user.reducer'
import { getAuthState } from './auth.selectors'

export const getUserState = (state: AppState) => state.user

export const getAuthUser = createSelector(
  getUserState,
  fromUser.getUser
)



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/selectors/user.selectors.ts